import { Component } from "@angular/core";
import { IHeaderGroupAngularComp } from "@ag-grid-community/angular";
import { ColumnGroup, IHeaderGroupParams } from "ag-grid-community";

@Component({
  templateUrl: "header-group.component.html",
  styleUrls: ["header-group.component.css"],
})
export class HeaderGroupComponent implements IHeaderGroupAngularComp {
  public params: IHeaderGroupParams;
  public expanded: boolean;


  agInit(params: any): void {
    this.params = params;

    const columnGroup = params.columnGroup.getHierarchalParent();

    if (columnGroup) {
      columnGroup.addEventListener(
        "expandedChanged",
        this.onExpandChanged.bind(this)
      );
    } else {
      console.log(
        "Unable to attach expandedChanged listener to non-group column"
      );
    }
  }
  ngOnDestroy() {}

  expandOrCollapse() {
    this.params.setExpanded(!this.expanded);
  }


  onExpandChanged() {
    const isExpanded = this.checkExpanded(this.params.columnGroup);
    this.expanded = isExpanded;
  }

  checkExpanded(columnGroup: ColumnGroup): boolean {
    if (!columnGroup.getParent()) {
      return columnGroup.isExpanded(); 
    }

    return this.checkExpanded(columnGroup.getParent());
  }
}
